import React, { useState, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import Header from '../components/Header';
import Footer from '../components/Footer';
import { useReportAuth } from '../context/ReportAuthContext';
import myPdfBasic from './checkmycarhistory.com.au-Basic.pdf';
import myPdfComprehensive from './checkmycarhistory.com.au-Comprehensive.pdf';
import myPdPPSRSearchCertificate from './PPSRSearchCertificate.pdf';

const STATES = [
  { value: 'NSW', label: 'New South Wales (NSW)' },
  { value: 'VIC', label: 'Victoria (VIC)' },
  { value: 'QLD', label: 'Queensland (QLD)' },
  { value: 'SA',  label: 'South Australia (SA)' },
  { value: 'WA',  label: 'Western Australia (WA)' },
  { value: 'TAS', label: 'Tasmania (TAS)' },
  { value: 'NT',  label: 'Northern Territory (NT)' },
  { value: 'ACT', label: 'Australian Capital Territory (ACT)' },
];

const basicPrice = process.env.REACT_APP_BASIC_REPORT_PRICE ? parseFloat(process.env.REACT_APP_BASIC_REPORT_PRICE) : 8.00;
const comprehensivePrice = process.env.REACT_APP_COMPREHENSIVE_REPORT_PRICE ? parseFloat(process.env.REACT_APP_COMPREHENSIVE_REPORT_PRICE) : 18.00;

export default function Home() {
  const navigate = useNavigate();
  const { setSearchData } = useReportAuth();

  const [searchType, setSearchType] = useState('rego');
  const [state,      setState]      = useState('');
  const [vehicleId,  setVehicleId]  = useState('');
  const [error,      setError]      = useState('');

  const inputRef = useRef(null);

  const scrollToTextbox = (reportType) => {

    sessionStorage.setItem('session_reporttype', reportType);

    inputRef.current?.scrollIntoView({
      behavior: 'smooth',
      block: 'center',
    });

    inputRef.current?.focus();
  };

  function handleSubmit(e) {
    e.preventDefault();
    setError('');

    if (!vehicleId.trim()) {
      setError(`Please enter a ${searchType === 'vin' ? 'VIN' : 'registration number'}.`);
      return;
    }
    if (!state) {
      setError('Please select a state.');
      return;
    }

    setSearchData({ plate: vehicleId.trim().toUpperCase(), state, searchType });
    navigate('/report-types');
  }

  return (
    <>
      <Header />

      {/* Hero */}
      <section className="hero">
        <div className="hero-bg"></div>
        <div className="container">
          <div className="hero-content">
            <h1 className="hero-title">Order Vehicle History - Official PPSR Check</h1>
            <p className="hero-subtitle">A PPSR check is a crucial first step when buying a vehicle</p>

            <div className="search-card">
              <h2 className="search-card-title">Check Your Vehicle Now</h2>
              <h3 className="search-card-title">Download Sample Reports:</h3>
              <a href={myPdPPSRSearchCertificate} target="_blank" rel="noopener noreferrer">Sample PPSR Report (Austroads Approved Report)</a>
              <br />
              <a href={myPdfBasic} target="_blank" rel="noopener noreferrer">Sample Basic Report</a>
              <br/>
              <a href={myPdfComprehensive} target="_blank" rel="noopener noreferrer">Sample Comprehensive Report</a>
              <form className="search-form" onSubmit={handleSubmit}>

              <div className="form-row">
                <div className="form-group">              
              <div class="package-card">
  <div class="package-title">Package 1</div>

  <div class="package-subtitle">
    Get 2 Reports
  </div>

  <div class="package-description">
    PPSR &amp; Basic <br/> Vehicle Report
  </div>

  <div class="package-highlight"  onClick={() => scrollToTextbox('basic')}>
    Price: ${basicPrice}
  </div>
</div>
</div>

<div className="form-group">
<div class="package-card">
  <div class="package-title">Package 2</div>

  <div class="package-subtitle">
    Get 2 Reports
  </div>

  <div class="package-description">
    PPSR &amp; Comprehensive <br/> Vehicle Report
  </div>

  <div class="package-highlight" onClick={() => scrollToTextbox('comprehensive')}>
    Price: ${comprehensivePrice}
  </div>
</div>
</div>
</div>

                <div className="form-row">
                  <div className="form-group">
                    <label htmlFor="searchType">Search By</label>
                    <select
                      id="searchType"
                      value={searchType}
                      onChange={(e) => { setSearchType(e.target.value); setVehicleId(''); }}
                    >
                      <option value="rego">Registration Number</option>
                      {/*<option value="vin">VIN (Vehicle ID Number)</option>*/}
                    </select>
                  </div>
                  <div className="form-group">
                    <label htmlFor="state">State</label>
                    <select
                      id="state"
                      value={state}
                      onChange={(e) => setState(e.target.value)}
                      required
                    >
                      <option value="">Select State</option>
                      {STATES.map((s) => (
                        <option key={s.value} value={s.value}>{s.label}</option>
                      ))}
                    </select>
                  </div>
                </div>

                <div className="form-group">
                  <label htmlFor="vehicleId">
                    {searchType === 'vin' ? 'VIN Number' : 'Registration Number'}
                  </label>
                  <input
                    ref={inputRef}
                    type="text"
                    id="vehicleId"
                    value={vehicleId}
                    onChange={(e) => setVehicleId(e.target.value.toUpperCase())}
                    placeholder={searchType === 'vin' ? 'e.g., JHMCM56557C123456' : 'e.g., ABC123'}
                    maxLength={searchType === 'vin' ? 17 : 10}
                    required
                  />
                  <small className="form-hint">
                    Enter your vehicle {searchType === 'vin' ? 'VIN' : 'registration'} number
                  </small>
                </div>

                {error && <p className="form-error">{error}</p>}

                <button type="submit" className="btn btn-primary btn-large">
                  <i className="fas fa-search"></i> Get Report
                </button>
              </form>
            </div>

            <div className="trust-indicators">
              <div className="trust-item"><i className="fas fa-lock"></i><span>Secure Payment</span></div>
              <div className="trust-item"><i className="fas fa-bolt"></i><span>Instant Report</span></div>
              <div className="trust-item"><i className="fas fa-certificate"></i><span>Official PPSR</span></div>
              <div className="trust-item"><i className="fas fa-shield-alt"></i><span>Data Protected</span></div>
            </div>
          </div>
        </div>
      </section>

      {/* How It Works */}
      <section className="how-it-works">
        <div className="container">
          <h2 className="section-title">How Does It Work?</h2>
          <div className="steps-grid">
            <div className="step-card">
              <div className="step-number">1</div>
              <div className="step-icon"><i className="fas fa-keyboard"></i></div>
              <h3>Enter Vehicle Details</h3>
              <p>Enter your VIN or Registration number with the state where the vehicle is registered</p>
            </div>
            <div className="step-card">
              <div className="step-number">2</div>
              <div className="step-icon"><i className="fas fa-credit-card"></i></div>
              <h3>Secure Payment</h3>
              <p>Choose your report type and complete payment securely via Stripe</p>
            </div>
            <div className="step-card">
              <div className="step-number">3</div>
              <div className="step-icon"><i className="fas fa-file-download"></i></div>
              <h3>Download Report</h3>
              <p>Get your instant PPSR certificate and reveal the vehicle's true history</p>
            </div>
          </div>
        </div>
      </section>

      {/* Features */}
      <section className="features">
        <div className="container">
          <h2 className="section-title">What's Included in the Report?</h2>
          <p className="section-subtitle">A PPSR search provides comprehensive checks to protect your investment</p>
          <div className="features-grid">
            {[
              { icon: 'fa-car-crash',      title: 'Written Off Records',    desc: "Check if the vehicle has been declared a statutory or repairable write-off" },
              { icon: 'fa-dollar-sign',    title: 'Finance Owing',          desc: "Discover if there is any outstanding finance or money owing on the vehicle" },
              { icon: 'fa-tachometer-alt', title: 'Odometer Check',         desc: "Verify odometer readings and detect potential tampering" },
              { icon: 'fa-user-secret',    title: 'Stolen Vehicle Check',   desc: "Find out if the vehicle has been reported as stolen" },
              { icon: 'fa-id-card',        title: 'Registration Details',   desc: "Access complete registration history and current status" },
              { icon: 'fa-check-circle',   title: 'VIN Validation',         desc: "Confirm the VIN matches the vehicle description and history" },
            ].map((f) => (
              <div className="feature-card" key={f.title}>
                <div className="feature-icon"><i className={`fas ${f.icon}`}></i></div>
                <h3>{f.title}</h3>
                <p>{f.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Pricing CTA */}
      <section className="pricing-cta">
        <div className="container">
          <div className="pricing-cta-content">
            <h2>Buy Your PPSR Report Online</h2>
            <p>Quick, instant access to a vehicle's history</p>
            <a href="/report-types" className="btn btn-white btn-large" onClick={(e) => { e.preventDefault(); navigate('/report-types'); }}>
              <i className="fas fa-arrow-right"></i> View Report Options
            </a>
          </div>
        </div>
      </section>

      {/* Why PPSR */}
      <section className="why-ppsr">
        <div className="container">
          <div className="why-ppsr-grid">
            <div className="why-ppsr-content">
              <h2>Why Use PPSR?</h2>
              <p>checkmycarhistory.com.au provides quick and easy access to conduct searches of the Personal Property Security Register (PPSR). It helps protect consumers when they are buying cars, motorbikes, boats and other personal assets.</p>
              <ul className="check-list">
                <li><i className="fas fa-check-circle"></i> Protect yourself from buying a vehicle with hidden debts</li>
                <li><i className="fas fa-check-circle"></i> Avoid stolen or written-off vehicles</li>
                <li><i className="fas fa-check-circle"></i> Official government register access</li>
                <li><i className="fas fa-check-circle"></i> Instant, secure online reports</li>
                <li><i className="fas fa-check-circle"></i> Comprehensive vehicle history data</li>
              </ul>
            </div>
            <div className="why-ppsr-image">
              <div className="stats-card">
                <div className="stat"><div className="stat-number">2M+</div><div className="stat-label">Reports Generated</div></div>
                <div className="stat"><div className="stat-number">99.9%</div><div className="stat-label">Uptime</div></div>
                <div className="stat"><div className="stat-number">24/7</div><div className="stat-label">Available</div></div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </>
  );
}
